// extracted by mini-css-extract-plugin
export default {"container":"Showcase_container__f9js8","title":"Showcase_title__Mojz5","imgBox":"Showcase_imgBox__lhseZ","img":"Showcase_img__Tr+dS","moveInLeft":"Showcase_moveInLeft__BekL0"};